// card-media.js
// Hover-swap for product cards: swap main image on thumbnail hover/focus,
// and restore the original when leaving the card. Runs once per page.

(() => {
  // guard: prevent re-init if script is included twice
  if (window.__cardMediaInit) return;
  window.__cardMediaInit = true;

  /** Add loading class, swap src/srcset, remove loading when the image finishes. */
  function setMainImage(main, nextSrc, nextSet) {
    if (!main || (!nextSrc && !nextSet)) return;

    // visual feedback while a new image is loading (opacity transition in CSS)
    main.classList.add('is-loading');

    const onLoad = () => {
      main.classList.remove('is-loading');
      main.removeEventListener('load', onLoad);
    };
    // remove the class when the new source finishes loading
    main.addEventListener('load', onLoad, { once: true });

    // apply srcset first so the browser can pick the right source
    if (nextSet) main.setAttribute('srcset', nextSet);
    if (nextSrc) main.setAttribute('src', nextSrc);

    // if already in cache, ensure the class is cleared on next frame
    if (main.complete) {
      requestAnimationFrame(() => main.classList.remove('is-loading'));
    }
  }

  /** Swap from a hovered/focused thumbnail inside the same card media block. */
  function swapFromThumb(thumb) {
    if (!thumb) return;
    const wrap = thumb.closest('.card__media');
    if (!wrap) return;

    const main = wrap.querySelector('img[data-main-image]');
    if (!main) return;

    const nextSrc = thumb.getAttribute('data-full');
    const nextSet = thumb.getAttribute('data-srcset');
    setMainImage(main, nextSrc, nextSet);
  }

  /** Restore original main image (stored in data-orig-*) when leaving a card. */
  function resetCard(cardWrapper) {
    if (!cardWrapper) return;
    const media = cardWrapper.querySelector('.card__media');
    if (!media) return;

    const main = media.querySelector('img[data-main-image]');
    if (!main) return;

    const origSet = main.getAttribute('data-orig-srcset');
    const origSrc = main.getAttribute('data-orig-src');
    setMainImage(main, origSrc, origSet);
  }

  // --- Event delegation (single listeners for the whole page) ---

  // Hover over a thumbnail → swap
  document.addEventListener(
    'mouseover',
    (e) => {
      const thumb = e.target?.closest?.('.card-thumb-img');
      if (thumb) swapFromThumb(thumb);
    },
    { passive: true }
  );

  // Keyboard focus on a thumbnail → swap (accessibility)
  document.addEventListener('focusin', (e) => {
    const thumb = e.target?.closest?.('.card-thumb-img');
    if (thumb) swapFromThumb(thumb);
  });

  // Leaving the product card area → restore the original image
  document.addEventListener(
    'mouseout',
    (e) => {
      const card = e.target?.closest?.('.product-card-wrapper');
      if (!card) return;
      if (card.contains(e.relatedTarget)) return; // still inside the card
      resetCard(card);
    },
    { passive: true }
  );

  // Losing focus outside the product card → restore
  document.addEventListener('focusout', (e) => {
    const card = e.target?.closest?.('.product-card-wrapper');
    if (!card) return;
    if (card.contains(e.relatedTarget)) return;
    resetCard(card);
  });
})();